import { connect } from "react-redux";
import Button from "../../components/Button";
import ButtonDropDown from "../../components/ButtonDropDown";
import {
  assignAttendee,
  createIdentifier,
  openModal,
  updateProfile
} from "../../state/actions/attendeeProfileActions";
import AdditionalQuestions from "./AdditionalQuestions";
import colors from "./Colors";
import { css } from "emotion";

const buttonStyle = css({
  button: {
    color: "#323232 !important",
    borderColor: "#8e99a8 !important",
    fontSize: 14,
    "&:hover": {
      backgroundColor: "white !important",
      border: "solid 1px #8e99a8"
    }
  }
});
const textStyle = css({
  color: "#5a626c",
  fontSize: 14,
  fontWeight: 600,
  "@media(max-width: 600px)": {
    fontSize: 12
  }
});
const TicketList = props => {
  const { ticketTypeName, tickets, index } = props;
  const color = colors[index];
  return (
    <div>
      <h4 className={textStyle}>{`${ticketTypeName} (${tickets.length})`}</h4>
      {tickets.map(ticket => {
        return <TicketAssign color={color} ticket={ticket} {...props} />;
      })}
    </div>
  );
};

let TicketAssign = ({
  ticket,
  ticketTypeName,
  color,
  assignAttendee,
  openModal,
  profileLookup,
  attendeeProfile,
  buyerOrderIdentifier,
  disableReassigning,
  token
}) => {
  const { profiles, assigning } = attendeeProfile;
  const isAssigned = ticket.attendeeProfileId;
  const profile = isAssigned ? profileLookup[ticket.attendeeProfileId] : {};
  const buyerProfile = profiles.find(
    ({ profileIdentifier }) => buyerOrderIdentifier === profileIdentifier
  );
  const options = [
    {
      label: "Assign to me",
      dataCY: "assign-to-me",
      action: () => {
        assignAttendee(ticket._id, buyerProfile._id);
      }
    },
    {
      label: "Add new attendee",
      dataCY: "add-new-attendee",
      action: () => {
        openModal({ creatorOrderId: ticket.orderId }, ticket._id);
      }
    }
  ].concat(
    profiles
      .map(({ firstName, lastName, _id, profileIdentifier }) => {
        if (buyerOrderIdentifier === profileIdentifier) {
          return false;
        } else {
          return {
            label: `${firstName} ${lastName}`,
            action: () => {
              assignAttendee(ticket._id, _id);
            }
          };
        }
      })
      .filter(prof => prof)
  );

  const loading = assigning.loading && assigning.ticketId === ticket._id;

  return (
    <div
      style={{
        display: "flex",
        border: "1px solid #DEDEDE",
        borderRadius: 4,
        alignItems: "center",
        marginBottom: 12,
        flexDirection: "column"
      }}
    >
      <div style={{ display: "flex", width: "100%", flexDirection: "row" }}>
        <div
          style={{
            minWidth: 12,
            backgroundColor: color,
            borderTopLeftRadius: 4,
            borderBottomLeftRadius: 4,
            marginRight: 8
          }}
        />
        <div
          style={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            paddingTop: 9
          }}
        >
          <h4 style={{ marginBottom: 0, wordBreak: "break-word" }}>
            {ticketTypeName}
          </h4>
          {isAssigned && profile ? (
            <div style={{ color: "#323232", fontSize: 12 }}>{`${
              profile.firstName
            } ${profile.lastName}`}</div>
          ) : null}
        </div>
        {!disableReassigning ? (
          <div style={{ margin: 12, minWidth: 125 }}>
            {loading ? (
              <div
                class="loading loading-lg"
                style={{ padding: "0 0 10px 0", marginRight: 10 }}
              />
            ) : isAssigned ? (
              <div className={buttonStyle}>
                <Button
                  onClick={() => {
                    openModal(profile, ticket._id, false);
                  }}
                  height={32}
                >
                  Edit Ticket
                </Button>
              </div>
            ) : (
              <ButtonDropDown
                dropDownOptions={options}
                buttonLabel={"Assign Ticket"}
                buttonProps={{ height: 32 }}
                dataCY={"assign-ticket"}
              />
            )}
          </div>
        ) : null}
      </div>
      {isAssigned && !loading ? (
        <AdditionalQuestions
          form={`assignedAdditionalQuestions-${ticket._id}`}
          ticketId={ticket._id}
          token={token}
        />
      ) : null}
    </div>
  );
};

TicketAssign = connect(
  (state, ownProps) => {
    return {
      attendeeProfile: state.attendeeProfile,
      buyerOrderIdentifier: createIdentifier(state.order.data)
    };
  },
  {
    openModal,
    assignAttendee,
    updateProfile
  }
)(TicketAssign);

export default TicketList;



// WEBPACK FOOTER //
// ./routes/conferences/TicketList.js